import React from 'react'

const CustomMultiValue = props => {
  const { getValue, data } = props;

  const selectedOptions = getValue()
  const currentOptionIdx = selectedOptions.findIndex(
    (option) => option.value === data.value
  )

  return (
    <span style={{ marginRight: "7.5px", width: "100%"}}>
      {data.label}
      {currentOptionIdx === selectedOptions.length - 1 ? "" : ", "}
    </span>
  );
}

export default CustomMultiValue
